import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';

@Injectable({
    providedIn: 'root'
})
export class PrescriptionService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService) {
        super(http, alertService, globalService);
    }

    get(consultId, data): Observable<any> {
        return this.getRequest(AppUrl.GET_PRESCRIPTIONS(consultId), data);
    }

    /*count(): Observable<any> {
        return this.getRequest(AppUrl.PRESCRIPTIONS_COUNT());
    }*/

    /*detail(id): Observable<any> {
        return this.getRequest(AppUrl.PRESCRIPTIONS(id));
    }*/
    create(id, data): Observable<any> {
        return this.postRequest(AppUrl.PRESCRIPTIONS(id), data);
    }

   /* update(id, data): Observable<any> {
        return this.putRequest(AppUrl.PRESCRIPTIONS(id), data);
    }*/
}
